/*
 * File: /src/store/modules/appConfig.js
 * Created Date: Saturday March 16th 2019
 * Author: Nicolas Wegener
 * -----
 * Last Modified: Sunday, 17th March 2019 4:19:09 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import configService from 'src/services/configService';

const state = {
  appConfig: undefined // User defined config loaded from BE
};

const getters = {
  getAppConfig: (state) => state.appConfig,
};
const actions = {
  async fetchAppConfig({ commit, state, rootGetters }) {
    // Only load the data once
    if (state.appConfig == undefined) {
      return configService.fetchUserConfig()
      .then(r => {
        commit('setAppConfig', r.data);
      });
    }
  },
  unloadAppConfig({ commit }) {
    commit('setAppConfig', undefined);
  }
};
const mutations = {
  setAppConfig(state, appConfig) {
    state.appConfig = appConfig;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
